import { render, staticRenderFns } from "./ShainDetails.vue?vue&type=template&id=7f4e9146"
import script from "./ShainDetails.vue?vue&type=script&lang=js"
export * from "./ShainDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports